// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-body h5.title{
  color: #000;
}

.btns-group{
  border-top: 1px solid #e7e7e7;
  padding: 20px 0 0 0;
  margin: 20px 0 0 0;
}

.btns-group button{
  min-width: 100px;
}

input[type="file"] {
  display: none;
}

.custom-file-upload {
  border: none;
  /* background-color: #dc3545; */
  color: #fff;
  border-radius: 4px;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}

.jcrop-border{
  max-width: 220px;
}

.jcrop-border img{
  width: 100%;
}

.jcrop-border span,
.current-image span{
  font-size: 13px;
  display: inline-block;
  margin-bottom: 5px;
}

/* .current-image{
  max-width: 150px;
  padding: 2px;
  margin: 0 auto;
}

.current-image img{
  width: 100%;
  border: 1px solid #e7e7e7;
  padding: 2px;
  width: 100px;
  height: 100px;
  border-radius: 50%;
} */

.current-image{
  width: 100%;
  padding: 2px;
  margin: 0 auto;
}

.current-image img{
  width: 100%;
  height: 100%;
  border: 1px solid #e7e7e7;
  padding: 2px;
  /* border-radius: 50%; */
}

._coverImage-holder {
  padding: 25px 40px;
  background-color: black;
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 20px;
}

.container {
  display: flex;
  flex-direction: column;
  position: relative;
  /* margin-top: 25px; */
}

.crop-container {
  height: 150px;
  width: 150px;
}

.controls {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-left: 10%;
  padding-right: 10%;
  /*position: absolute;*/
  margin-top:20px;
  bottom: -15px;
}`, "",{"version":3,"sources":["webpack://./src/components/ProfilePhoto.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;GAaG;;AAEH;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,aAAa;AACf","sourcesContent":[".app-body h5.title{\r\n  color: #000;\r\n}\r\n\r\n.btns-group{\r\n  border-top: 1px solid #e7e7e7;\r\n  padding: 20px 0 0 0;\r\n  margin: 20px 0 0 0;\r\n}\r\n\r\n.btns-group button{\r\n  min-width: 100px;\r\n}\r\n\r\ninput[type=\"file\"] {\r\n  display: none;\r\n}\r\n\r\n.custom-file-upload {\r\n  border: none;\r\n  /* background-color: #dc3545; */\r\n  color: #fff;\r\n  border-radius: 4px;\r\n  display: inline-block;\r\n  padding: 6px 12px;\r\n  cursor: pointer;\r\n}\r\n\r\n.jcrop-border{\r\n  max-width: 220px;\r\n}\r\n\r\n.jcrop-border img{\r\n  width: 100%;\r\n}\r\n\r\n.jcrop-border span,\r\n.current-image span{\r\n  font-size: 13px;\r\n  display: inline-block;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n/* .current-image{\r\n  max-width: 150px;\r\n  padding: 2px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.current-image img{\r\n  width: 100%;\r\n  border: 1px solid #e7e7e7;\r\n  padding: 2px;\r\n  width: 100px;\r\n  height: 100px;\r\n  border-radius: 50%;\r\n} */\r\n\r\n.current-image{\r\n  width: 100%;\r\n  padding: 2px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.current-image img{\r\n  width: 100%;\r\n  height: 100%;\r\n  border: 1px solid #e7e7e7;\r\n  padding: 2px;\r\n  /* border-radius: 50%; */\r\n}\r\n\r\n._coverImage-holder {\r\n  padding: 25px 40px;\r\n  background-color: black;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: relative;\r\n  /* margin-top: 25px; */\r\n}\r\n\r\n.crop-container {\r\n  height: 150px;\r\n  width: 150px;\r\n}\r\n\r\n.controls {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n  padding-left: 10%;\r\n  padding-right: 10%;\r\n  /*position: absolute;*/\r\n  margin-top:20px;\r\n  bottom: -15px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
